// jQuery
jQuery(function ($) {
  // -----------------------------
  // gnav
  // -----------------------------
  $('.gnavBtn').on('click', function () {
    $(this).toggleClass('is-open');
    $('.gnav').toggleClass('is-open');
    var expanded = $(this).attr('aria-expanded') === 'true';
    $(this).attr('aria-expanded', !expanded);
    var label = $(this).attr('aria-label') === 'メニューを開く' ? 'メニューを閉じる' : 'メニューを開く';
    $(this).attr('aria-label', label);
    var hidden = $('.gnav').attr('aria-hidden') === 'true';
    $('.gnav').attr('aria-hidden', !hidden);
  });
  $('.gnav a').on('click', function () {
    $('.gnav').removeClass('is-open');
    $('.gnavBtn').removeClass('is-open');
    $('.gnavBtn').attr('aria-expanded', 'false');
    $('.gnavBtn').attr('aria-label', 'メニューを開く');
    $('.gnav').attr('aria-hidden', 'true');
  });

  $('.gnav-item').hover(
    function () {

      //マウスカーソルが重なった時の処理
      $(this).addClass('is-open');

    },
    function () {

      //マウスカーソルが離れた時の処理
      $(this).removeClass('is-open');

    }
  );

  // -----------------------------
  // TOP　header
  // -----------------------------
  $(window).scroll(function () {
    if ($(window).scrollTop() > 500) {
      $('.header._top').addClass('is-scroll');
    } else {
      $('.header._top').removeClass('is-scroll');
    }
  });

  // -----------------------------
  // totop
  // -----------------------------
  // ボタンをクリックしたらスクロールして上に戻る
  var topBtn = $('.totop');

  topBtn.click(function () {
    $('body,html').animate({
      scrollTop: 0
    }, 300, 'swing');
    return false;
  });

  // -----------------------------
  // アコーディオン
  // -----------------------------
  $('.js-accordion').click(function () {   // アコーディオンメニュー全体
    $(this).next('.js-accordion-contents').slideToggle();   // アコーディオンの隠されている要素
    $(this).toggleClass("is-show");   // メニューが開いたときのスタイル変化
  });

  // -----------------------------
  // モーダル
  // -----------------------------
  $(function () {
    // ページが読み込まれたときにURLパラメーターをチェックし、指定されたモーダルを開く
    var urlParams = new URLSearchParams(window.location.search);
    var modalToOpen = urlParams.get('modal');
    if (modalToOpen) {
      $('#' + modalToOpen).fadeIn();
    }

    // クリックされた要素に応じてモーダルを開く
    $('.js-modal-open').each(function () {
      $(this).on('click', function () {
        var target = $(this).data('target');
        $('#' + target).fadeIn();
        return false;
      });
    });

    // モーダルを閉じる
    $('.js-modal-close').on('click', function () {
      $('.js-modal').fadeOut();
      return false;
    });

    // 別モーダルに移動する場合の処理　必要なければいらない
    $('.js-modal-move').each(function () {
      $(this).on('click', function () {
        var target = $(this).data('target');
        var modal = document.getElementById(target);
        $(modal).fadeIn();
        $(this).parents('.js-modal').fadeOut();
        return false;
      });
    });
  });

  // -----------------------------
  // タブ切り替え
  // -----------------------------
  $(document).ready(function () {
    // 1. URLパラメーターの解析
    var urlParams = new URLSearchParams(window.location.search);
    var tabParam = urlParams.get('tab'); // ?tab=1 の値を取得
    var tabs = $('.js-tab');

    if (tabParam) {
      // パラメーターがある場合、そのタブをアクティブに
      var idx = parseInt(tabParam, 10) - 1; // インデックス用に -1 する
      if (idx >= 0 && idx < tabs.length) {
        activateTab(idx);
      } else {
        activateTab(0); // 範囲外ならデフォルトで最初のタブを表示
      }
    } else {
      // パラメーターがない場合、デフォルトで最初のタブをアクティブに
      activateTab(0);
    }

    // 2. タブのクリックイベント
    tabs.on('click', function () {
      var idx = tabs.index(this);
      activateTab(idx);

      // URLパラメーターを更新
      var newUrl = new URL(window.location.href);
      newUrl.searchParams.set('tab', idx + 1); // ?tab=1, ?tab=2 のように更新
      history.replaceState(null, '', newUrl.toString()); // 履歴を更新
    });

    // 3. タブをアクティブにする関数
    function activateTab(index) {
      tabs.removeClass('is-active').eq(index).addClass('is-active');
      var panelArea = tabs.eq(index).closest('.js-tab_area').next('.js-panel_area');
      var panels = panelArea.find('.js-panel');
      panels.removeClass('is-active').eq(index).addClass('is-active');
    }
  });

  // -----------------------------
  // お知らせ
  // -----------------------------
  // TAGS
  $(document).ready(function () {
    $('.tags__item').on("click", function () {
      $(this).toggleClass('selected-tag');
    });

    $('.tags__search').on('click', function () {
      // get selected tags
      const selectedItems = $('.tags__item.selected-tag').map(function () {
        var tag = $(this).data('slug');
        return tag;
      }).get();

      const currentUrl = new URL(window.location.href);
      const params = new URLSearchParams(currentUrl.search);
      var newUrl = `${currentUrl.origin}${currentUrl.pathname}`;

      if (selectedItems.length > 0) {
        const tags = selectedItems.map(tag => tag.replace('#', '')).join(',');
        params.set('tags', tags);
        newUrl = `${currentUrl.origin}${currentUrl.pathname}?${decodeURIComponent(params.toString())}`;
      }


      window.location.href = newUrl;
    });

    $('.tags__clear').on("click", function () {
      $('.tags__item').removeClass('selected-tag');
    });
  });

  // -----------------------------
  // フォーム
  // -----------------------------
  // hide policy privacy checkbox span
  $(".cbPrivacyPolicy .wpcf7-list-item-label").hide();
});

// JavaScript